import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RegiaoIntegracaoErpImportService {
    /** Evento executado após finalizar a importação das regiões do ERP */
    afterImport = new Subject<void>();

    /** Emite o evento de finalização da importação das regiões do ERP */
    emitAfterImport() {
        this.afterImport?.next();
    }
}
